import * as Html from "../../util/Html.ts";

function initDom(theNode: HTMLElement): void {
  // FIXME: remplacer previousElementSibling par une sélection plus explicite
  const input = theNode.previousElementSibling as HTMLElement | null;
  if (!input) return;

  input.addEventListener('keydown', (event: KeyboardEvent) => {
    const down = event.key === 'ArrowDown' || (event.key === 'Tab' && !event.shiftKey);
    const up = event.key === 'ArrowUp' || (event.key === 'Tab' && event.shiftKey);
    const enter = event.key === 'Enter' || event.keyCode === 10; // pour compatibilité

    // Empêche le tab par défaut si leNode contient des éléments
    if (event.key === 'Tab') {
      event.preventDefault();
    }

    // ↓ flèche bas
    if (down) {
      const selected = theNode.querySelector('.selected') as HTMLElement | null;
      let next: HTMLElement | null = null;

      if (selected) {
        selected.classList.remove('selected');
        next = selected.nextElementSibling as HTMLElement | null;
      }

      if (!next) {
        next = theNode.firstElementChild as HTMLElement | null;
      }

      if (next) {
        next.classList.add('selected');
        next.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      return;
    }

    // ↑ flèche haut
    if (up) {
      const selected = theNode.querySelector('.selected') as HTMLElement | null;
      let prev: HTMLElement | null = null;

      if (selected) {
        selected.classList.remove('selected');
        prev = selected.previousElementSibling as HTMLElement | null;
      }

      if (!prev) {
        prev = theNode.lastElementChild as HTMLElement | null;
      }

      if (prev) {
        prev.classList.add('selected');
        prev.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      return;
    }

    // Entrée
    if (enter) {
      const selected = theNode.querySelector('.selected') as HTMLElement | null;
      if (selected) {
        selected.dispatchEvent(new Event('click', { bubbles: true }));
      }
    }
  });
}

Html.registerWidget('widget/form/selectableByKeyBoard',{initDom})